import React, { Component } from "react";
import { injectIntl } from "react-intl";
import { withRouter } from "react-router-dom";
import styled from "styled-components";
import { Typography } from "@material-ui/core";
import ButtonWithTooltip from "../../components/UI/Buttons/ButtonWithTooltip";
import errorBook from "../../assets/images/errorBook.svg";

const StyledWrapper = styled.div`
  width: 100%;
  height: 100%;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

const StyledBookImage = styled.img`
  width: 200px;
  margin-bottom: 20px;
`;

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null, errorInfo: null };
    this.firebase = this.props.firebase;
    this.intl = this.props.intl;
    this.history = this.props.history;
  }

  componentDidCatch(error, errorInfo) {
    // Catch errors in any components below and re-render with error message
    this.setState({
      error: error,
      errorInfo: errorInfo,
    });
    console.log(error.message);
    // Log error in firebase log
    const clientErrorLog = this.firebase
      .functions()
      .httpsCallable("clientErrorLog");
    clientErrorLog({
      message: error.message,
      componentStack: errorInfo.componentStack,
    });
  }

  render() {
    // Render error page if we catch some error
    if (this.state.errorInfo) {
      return (
        <StyledWrapper>
          <StyledBookImage src={errorBook} alt="Book in progress" />
          <Typography color="primary" variant="h6" style={{ width: "300px" }}>
            {this.intl.formatMessage({
              id: "ERROR.GENERIC",
              defaultMessage:
                "Oops. Something went wrong, refresh page and try again.",
            })}
          </Typography>
          <ButtonWithTooltip
            buttoncolor="white"
            backgroundcolor="yellow"
            buttonsize="large"
            margin={[30, 0, 0, 0]}
            onClick={() => {
              this.history.push(process.env.PUBLIC_URL);
              window.location.reload();
            }}
          >
            {this.intl.formatMessage({
              id: "ERROR.GENERIC_BUTTON",
              defaultMessage: "Refresh",
            })}
          </ButtonWithTooltip>
        </StyledWrapper>
      );
    }

    // Render children if there is no error
    return this.props.children;
  }
}

export default withRouter(injectIntl(ErrorBoundary));
